import type { ApiConfig } from '../../types'

export const withdrawalHistoryApiConfig = {
  existSubType: false,
  fetchableRange: (90 * 24 - 1) * 60 * 60 * 1000, // 90 days in milliseconds
  limit: 1000,
  order: 'desc',
  range: 7 * 24 * 60 * 60 * 1000, // 7 days in milliseconds
  requiresRange: true,
  type: 'withdrawal-history',
} as const satisfies ApiConfig
